<template>
  <Tab @close="removeCurrent">
    <template #toolbar-items>
      <!-- ------------------------ FAIRE CONNAITRE SECURATING ------------------------ -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'promote'"
          icon="fa-share-alt"
          name="promote"
      ></TabToolbarButton>
      <!-- ------------------------ ENVOYER UNE INVITATION A DEPOSER UN AVIS ------------------------ -->
      <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'invite'"
          icon="fa fa-star"
          name="invite"
      ></TabToolbarButton>
    </template>
    <template #container>
      <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="snackbarTimeout"
          :multi-line="true"
          text
          outlined
          tile
          app
          top
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn icon @click="snackbar = false">
            <v-icon :color="snackbarColor" small>fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <!-- ------------------------ promote ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="me/social/page" name="promote">
        <template #content>
          <v-tabs vertical>
            <v-tab target="promote_tab_mail"
                   style="justify-content: normal;"
            >
              <v-icon style="color: inherit;" left>fa-envelope</v-icon>
              {{ $t("social.email.menu_name") }}
            </v-tab>
            <v-tab target="promote_tab_facebook"
                style="justify-content: normal;"
            >
              <v-icon left>fab fa-facebook</v-icon>
              {{ $t("social.facebook.menu_name") }}
            </v-tab>
            <v-tab target="promote_tab_twitter"
                   style="justify-content: normal;"
            >
              <v-icon left>fab fa-twitter</v-icon>
              {{ $t("social.twitter.menu_name") }}
            </v-tab>
            <v-tab target="promote_tab_whatsapp"
                   style="justify-content: normal;"
            >
              <v-icon left>fab fa-whatsapp</v-icon>
              {{ $t("social.whatsapp.menu_name") }}
            </v-tab>
            <v-tab target="promote_tab_linkedin"
                   style="justify-content: normal;"
            >
              <v-icon left>fab fa-linkedin</v-icon>
              {{ $t("social.linkedin.menu_name") }}
            </v-tab>

            <v-tab-item target="promote_content_mail">
              <v-card style="margin-left: 10px;">
                <v-card-text>
                  <v-text-field
                      v-model="email.to"
                      :label="$t('social.email.contacts')"
                      type="email"
                  ></v-text-field>
                  <div class="tw-mt-2">
                    <div class="tw-mb-2">{{ $t("social.email.subject") }}</div>
                    <v-text-field v-model="email.subject" readonly></v-text-field>
                  </div>
                  <div>
                    <div class="tw-mb-2">{{ $t("social.email.message") }}</div>
                    <v-textarea v-model="email.message" auto-grow readonly></v-textarea>
                  </div>
                  <div class="tw-mb-2">{{ $t("social.warning") }}</div>
                  <div>
                    <v-btn :disabled="!checkEmailAddress(email.to)" color="primary" small @click="emailSubmit">
                      {{ $t("social.email.submit") }}
                    </v-btn>
                    <v-btn class="tw-ml-4" small @click="emailClear">
                      {{ $t("social.email.clear") }}
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item target="promote_content_facebook">
              <v-card style="margin-left: 10px;">
                <v-card-text>
                  <v-btn small :href="facebookUrl" color="primary" target="_blank">
                    {{ $t("social.facebook.share") }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item target="promote_content_twitter">
              <v-card style="margin-left: 10px;">
                <v-card-text>
                  <v-textarea v-model="twitter.message" :label="$t('social.twitter.message')" auto-grow></v-textarea>
                  <v-btn small :href="twitterUrl" color="primary" target="_blank">
                    {{ $t("social.twitter.share") }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item target="promote_content_whatsapp">
              <v-card style="margin-left: 10px;">
                <v-card-text>
                  <v-text-field v-model="whatsapp.phone" :label="$t('social.whatsapp.phone')" type="tel"></v-text-field>
                  <v-textarea v-model="whatsapp.message" :label="$t('social.whatsapp.message')" auto-grow></v-textarea>
                  <v-btn small :href="whatsappUrl" color="primary" target="_blank">
                    {{ $t("social.whatsapp.share") }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item target="promote_content_linkedin">
              <v-card style="margin-left: 10px;">
                <v-card-text>
                  <v-btn small :href="linkedinUrl" color="primary" target="_blank">
                    {{ $t("social.linkedin.share") }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </template>
      </TabPage>
      <!-- ------------------------ invite ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="me/social/page" name="invite">
        <template #content>
          <v-card>
            <v-card-text>
              <div class="tw-mt-2">
                <div class="tw-mb-2">{{ $t("social.invite.website") }}</div>
                <v-text-field v-model="invite.website" type="url" :error="!invite.website_ok" :error-messages="!invite.website_ok?$t('social.invite.website_error'):''" :placeholder="$t('social.invite.website_placeholder')"></v-text-field>
              </div>
              <div class="tw-mt-2">
                <div class="tw-mb-2">{{ $t("social.invite.thematic") }}</div>
                <v-select v-model="invite.thematic" :items="thematics" item-value="id" item-text="thematic"></v-select>
              </div>
              <div class="tw-mt-2">
                <div class="tw-mb-2">{{ $t("social.invite.email") }}</div>
                <v-text-field v-model="invite.to" type="email"></v-text-field>
              </div>
              <div class="tw-mt-2">
                <div class="tw-mb-2">{{ $t("social.invite.first_name") }}</div>
                <v-text-field v-model="invite.first_name" type="text"></v-text-field>
              </div>
              <div>
                <div class="tw-mb-2">{{ $t("social.invite.message") }}</div>
                <v-textarea v-model="invite.message" :placeholder="$t('social.invite.message_placeholder')"></v-textarea>
              </div>
              <div>
                <v-btn :loading="inviteLoading" :disabled="!checkEmailAddress(invite.to)||!checkWebSite(invite.website)" color="primary" small @click="inviteSubmit">
                  {{ $t("social.email.submit") }}
                </v-btn>
                <v-btn class="tw-ml-4" small @click="inviteClear">
                  {{ $t("social.email.clear") }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import { mapState } from "vuex"
import { Types } from "@/store/modules/snackbar"

export default {
  name: "Social",
  mixins: [tab],
  data: () => ({
    valid: false,
    pages: ["email", "facebook", "twitter", "whatsapp", "linkedin", "history"],
    page: "promote",
    menu: "social",
    snackbar: false,
    snackbarTimeout: 2000,
    snackbarText: "",
    snackbarColor: "success",
    thematics: [],
    invite: {
      to: "",
      message: "",
      first_name: "",
      website: "",
      website_ok: true,
      thematic: "",
    },
    email: {
      to: "",
      haveAlreadySentEmails: false,
      subject: "",
      message: "",
    },
    twitter: {
      message: "",
    },
    whatsapp: {
      phone: "",
      message: "",
    },
    inviteLoading: false,
  }),
  mounted() {
    this.fetchEmailTemplate()
    this.getThematics()
  },
  computed: {
    ...mapState("auth", ["user"]),
    url() {
      return window.location
    },
    facebookUrl() {
      const parsedUrl = encodeURIComponent(this.url)
      return `https://www.facebook.com/sharer/sharer.php?u=${parsedUrl}&src=sdkpreparse`
    },
    twitterUrl() {
      const parsedUrl = "" // encodeURIComponent(this.url);
      const parsedDescription = encodeURIComponent(this.twitter.message)
      return `https://twitter.com/intent/tweet?text=${parsedDescription}&url=${parsedUrl}&hashtags=securating&via=securating`
    },
    whatsappUrl() {
      const phone = encodeURIComponent(this.whatsapp.phone)
      const parsedDescription = encodeURIComponent(this.whatsapp.message)
      const desktopUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${parsedDescription}`
      const mobileUrl = `whatsapp://send?phone=${phone}&text=${parsedDescription}`
      return this.$mobilecheck() ? mobileUrl : desktopUrl
    },
    linkedinUrl() {
      const parsedUrl = encodeURIComponent(this.url)
      return `https://www.linkedin.com/shareArticle?mini=true&url=${parsedUrl}&source=securating.com`
    },
  },
  methods: {
    getThematics() {
      this.$axios.get("/office/me/thematics/index").then(response => {
        this.thematics = response.data
        if(this.invite.thematic==="") {
          this.invite.thematic = this.thematics[0].id
        }
      })
    },
    emailClear() {
      this.email.to = ""
      this.email.message = ""
      this.email.subject = ""
      this.fetchEmailTemplate()
    },
    inviteClear() {
      this.invite.to = ""
      this.invite.website = ""
      this.invite.website_ok = true
      this.invite.message = ""
      this.invite.first_name = ""
      this.invite.thematic = this.thematics[0].id
    },
    emailSubmit() {
      this.$axios
        .post("/office/me/users/emails/share", {
          to: this.email.to,
          subject: this.email.subject,
          body: this.email.message,
        })
        .then(() => {
          this.$store.dispatch(Types.actions.PUSH_MESSAGE, {
            lines: this.$t("social.email.send"),
            config: { timeout: 1000 * 6, color: "success" },
          })
          this.emailClear()
          this.email.haveAlreadySentEmails = false
        })
    },
    inviteSubmit() {
      this.inviteLoading = true

      this.$axios.post( '/office/me/users/invitation/create',{
                              website: this.invite.website,
                              to: this.invite.to,
                              message: this.invite.message,
                              first_name: this.invite.first_name,
                              thematic: this.invite.thematic,
            }).then(() => {
              this.inviteLoading = false
              this.invite.website_ok = true
              this.snackbarText = this.$t("invitation.emailing.mail.ok")+this.invite.to
              this.snackbarColor = "success"
              this.snackbarTimeout = 4 * 1000
              this.snackbar = true
            }).catch(errors => {
              console.log(errors)
              this.inviteLoading = false
              this.invite.website_ok = false
            })
    },
    checkEmailAddress(email) {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    },
    checkWebSite(site) {
      return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi.test(site);
    },
    fetchEmailTemplate() {
      this.email.subject = this.$t("social.email.template.subject")
      this.email.message = this.$t("social.email.template.message")
    },
  },
}
</script>
